module.exports = __webpack_public_path__ + "static/top-banner-7190d72d070b63eb57733f50e334971c.png";